<template>
  <div>
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, onUnmounted, watch } from 'vue'
import type { Position } from './types/NavigationPane'
import { navigationStore } from './store/navigationStore'

// Mobile breakpoint
const MOBILE_BREAKPOINT = 768 // px

export default defineComponent({
  name: 'NavigationPaneProvider',
  props: {
    position: {
      type: String as () => Position,
      required: true
    }
  },
  setup(props) {
    // Update store with the position
    watch(
      () => props.position,
      (newPosition) => {
        navigationStore.updateConfig({ position: newPosition })
      },
      { immediate: true }
    )

    // Detect mobile view based on screen width
    const checkMobile = () => {
      navigationStore.setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    }

    onMounted(() => {
      // Check on initial render
      checkMobile()

      // Add event listener for window resize
      window.addEventListener('resize', checkMobile)
    })

    onUnmounted(() => {
      // Clean up
      window.removeEventListener('resize', checkMobile)
    })
  }
})
</script>
